// extracted by mini-css-extract-plugin
export default {"main":"SubLayout_main__Uvtrj","bg":"SubLayout_bg__yw0nU","image":"SubLayout_image__zBppj"};